import { Card, Column, Row, Tooltip } from 'components/Blocks';
import { DownloadFileButton } from 'components/Buttons';
import { UserAvatar } from 'components/UserAvatar';
import { TruncateText } from 'components/TruncateText';

import { FileUpIcon } from 'components/Icons';

import { useUser } from 'hooks/user';

import { dateDistanceToNow, formatPublishedAtDate } from 'utils/date';
import { fixFileName, getFirstAndLastName } from 'utils/text';

import { InvoiceTabProps } from './types';

export function InvoiceFiles({ invoice }: InvoiceTabProps): JSX.Element {
  const user = useUser();

  const canDownload = user.team.isInvoiceTeam;

  return (
    <Column>
      {invoice.files.map((file) => (
        <Card
          flow="row"
          key={file.id}
          justifyContent="space-between"
          className="phone:flex-col phone:items-start"
        >
          <Column>
            <Row gap="2" className="grow">
              <FileUpIcon color="primary" />

              <TruncateText
                text={fixFileName(file.name)}
                max={45}
                className="font-medium text-primary"
              />
            </Row>

            <Row gap="2">
              <UserAvatar
                user={file.uploadedBy}
                className="text-xs phone:!h-8 phone:!w-8"
                size={20}
              />

              <span className="text-sm font-medium">
                {getFirstAndLastName(file.uploadedBy.name)}
              </span>
            </Row>
          </Column>

          <Row className="ml-auto">
            {canDownload && <DownloadFileButton {...file} />}

            <Tooltip content={formatPublishedAtDate(file.uploadedAt)}>
              <span className="text-sm font-medium phone:text-xs">
                {dateDistanceToNow(file.uploadedAt)}
              </span>
            </Tooltip>
          </Row>
        </Card>
      ))}
    </Column>
  );
}
